<template>
    <div class="login">
        <div class="login-title">
            <span class="login-title-image"></span>
            <span class="login-title-text">停車場整合管理系統</span>
            <div class="login-title-partner"></div>
        </div>
        <form class="login__form" @submit.prevent @keyup.enter="postUserLogin()">
            <div class="login__form__item router">
                <span class="router-title">用戶登入</span>
                <router-link class="router-link-item" :to="`${root}/login/signIn`">{{$t("login.link.signInText")}}</router-link>
            </div>
            <lgn-form-item label-position="top" class="login__form__item email">
                <div slot="label" class="login__form__item-label">帳號</div>
                <lgn-input slot="input" type="email" v-model="email" placeholder="email"></lgn-input>
            </lgn-form-item>
            <lgn-form-item label-position="top" class="login__form__item password" :custom="true">
                <div slot="label" class="login__form__item-label">密碼</div>
                <lgn-input slot="input" type="password" v-model="password" placeholder="password"></lgn-input>
                <div class="lgn-form-item-custom" slot="custom">
                    <router-link class="login__form__item-router-link" :to="`${root}/login/forgetPassword`">{{$t("login.link.forgetPasswordText")}}?</router-link>
                </div>
            </lgn-form-item>
            <div class="login__form__item submit">
                <span class="submit-info">
                    <button type="button" class="submit-info-button checkbox-button" :class="{'is-check': remember==1}" @click="remember = (remember+1)%2"></button>
                    <span class="submit-info-text">記住我</span>
                </span>
                <el-button class="submit-button main-button" @click="postUserLogin()">登入</el-button>
            </div>
        </form>
        <el-dialog class="connection-dialog" :visible.sync="isConnectionOpen">
            <div slot="title">聯絡我們</div>
            <div class="connection-dialog__body">
                <div class="connection-dialog__body-item">
                    <div class="connection-dialog__body-item-label">信箱</div>
                    <a href="mailto: service@berryan.com" class="connection-dialog__body-item-value">service@berryan.com</a>
                </div>
                <div class="connection-dialog__body-item">
                    <div class="connection-dialog__body-item-label">電話</div>
                    <a href="tel: 0226968766" class="connection-dialog__body-item-value">02-26968766</a>
                </div>
            </div>
            <div slot="footer">
                <button type="button" class="connection-dialog__footer-button main-button" @click="closeConnectionDialog()">確認</button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import * as api from '@/script/apiService/api.js'
import lgnInput from '@/lgnComponents/lgnInput/lgnInput.vue'
import lgnFormItem from '@/lgnComponents/lgnForm/lgnFormItem.vue'
export default {
    name: 'login',
    data(){
        return{
            email: '',
            password: '',
            remember: 0,
            root: process.env.VUE_APP_PACACLOUND_ROOT,
            isConnectionOpen: false
        }
    },
    components: {
        lgnInput,
        lgnFormItem
    },
    methods: {
        async postUserLogin(){
            if(this.remember==0){
                localStorage.removeItem('memberEmail');
            }
            else{
                localStorage.setItem('memberEmail',this.email)
            }
            let res = await api.postUserLogin(this.email,this.password);
            if(!res.error_status){
                if(res.is_partner != 1 && res.is_admin != 1){
                    this.$store.commit({
                        type: "setUserInfo",
                        userInfo: null
                    })
                    this.$message.error({
                        duration: 2500,
                        showClose: true,
                        message: this.$t("login.login.accountInfoError")
                    })
                    return false;
                }
                this.$router.push(`${this.root}`);
            }else{
                this.$message.error({
                    duration: 2500,
                    showClose: true,
                    message: this.$t("login.login.accountInfoError")
                })
            }
        },
        openConnectionDialog(){
            this.isConnectionOpen = true;
        },
        closeConnectionDialog(){
            this.isConnectionOpen = false;
        }
    },
    mounted(){
        let localStorageEmail = localStorage.getItem('memberEmail')
        if(localStorageEmail){
            this.email = localStorageEmail;
            this.remember = 1;
        }

    }
}
</script>